import React from "react";
import * as aserver from '../../APIClient';
import { Button } from "@material-ui/core";
import PayPal from './payPal';
import Modal from '../comps/modal';
// import AephoriaLogo from "../images/Aephoria-logo-blue-login.png"
const axios = require('axios');


const modeRegister = 'register';
const modePostPayment = 'postpayment';
const pfItemDescription = "The Aephoria Enneagram Self-registered Pair Assessment."

const providerPayFast = 'PayFast';
const providerPayPal = 'PayPal';
const centers = {
  Gut: [8, 9, 1],
  Heart: [2, 3, 4],
  Head: [5, 6, 7],
};

function getLocalStorageValue(field, defaultValue) {
  return(localStorage.getItem('pairregister_'+field)??(defaultValue??''));
}

function setLocalStorageValue(field, value) {
  localStorage.setItem('pairregister_'+field, value);
}

function setCheckoutSpecificField(field, value) {
  localStorage.setItem(`pairregister_${field}_${localStorage.getItem('checkoutId')}`, value);
}

function getCheckoutSpecificField(field) {
  return(localStorage.getItem(`pairregister_${field}_${localStorage.getItem('checkoutId')}`));
}

function updatePartnerInstinct(partnerState, fieldKey, value) {
  const updated = { ...partnerState };

  if (fieldKey === "dominantInstinct") {
    if (updated.blindInstinct === value) {
      updated.blindInstinct = "";
    }
    updated.dominantInstinct = value;
  } else if (fieldKey === "blindInstinct") {
    if (value === updated.dominantInstinct) {
      return partnerState; // Cancel
    }
    updated.blindInstinct = value;
  } else {
    updated[fieldKey] = value;
  }

  return updated;
}


class PairRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: props.mode,
      // register:
      partnerA_firstName: getLocalStorageValue('partnerA_firstName'),
      partnerA_lastName: getLocalStorageValue('partnerA_lastName'),
      partnerA_email: getLocalStorageValue('partnerA_email'),
      partnerB_firstName: getLocalStorageValue('partnerB_firstName'),
      partnerB_lastName: getLocalStorageValue('partnerB_lastName'),
      partnerB_email: getLocalStorageValue('partnerB_email'),
      registerUUID: '',
      assessmentType: 'ennea',
      partnerA_AssessmentLanguage: getLocalStorageValue('partnerA_AssessmentLanguage', 'english'),
      partnerB_AssessmentLanguage: getLocalStorageValue('partnerB_AssessmentLanguage', 'english'),
      costOfAssessment: '',
      currency: '',
      checkoutId: "",
      provider: null,
      buttonClicked: false,
      message: "",
      coachValid: null,
      priceString: "",
      proceeding: false,
      // postpayment:
      isPaymentComplete: null,
      assessmentLink: "",
      bodyText: "",
      referenceNumber: "",
      response: null,
      error: null,
      packageOption:"",
      partnerA_trifix: '',
      partnerA_dominantInstinct: '',
      partnerA_blindInstinct: '',
      partnerB_trifix: '',
      partnerB_dominantInstinct: '',
      partnerB_blindInstinct: '',
      partnerA_enneagram:"",
      partnerB_enneagram:"",
      typeOfPairReport:"Couples",
      invoiceModal:false,
      totalCost:"",
      partnerA_gutType: '',
      partnerA_heartType: '',
      partnerA_headType: '',
      partnerB_gutType: '',
      partnerB_heartType: '',
      partnerB_headType: '',
      paypalCaptureUrl: "/pairpay/paypalcapture",
      pfItemName:"",
      currencyShorthand:"",
      hideCouples: false,
      hideCoachBlurb: false,
      isFree: false,
      freeRegistrationComplete: false
    };
  }

  async componentDidMount() {
    if (this.state.mode === modeRegister)
      this.initializeRegisterMode();
    if (this.state.mode === modePostPayment)
      this.initializePostPaymentMode();
  }

  async initializeRegisterMode() {
    const pathname = window.location.pathname;
    const parts = pathname.split('/');
    const registerUUID = parts[parts.length - 1];
    const coachValid = registerUUID.length === 36;
    const hideCouples = [
      '113ca761-2125-4dc2-b3a5-314209d1a325', // Professional Pairs Self-register
      'c854870f-3cc3-4780-a96c-cc1fa03c8b3d', // Aephoria Promotions
    ].includes(registerUUID);
    const hideCoachBlurb = [
      '113ca761-2125-4dc2-b3a5-314209d1a325', // Professional Pairs Self-register
      '05856ddf-ed04-30d7-3fb0-496cc8ad75a5', // Aephoria Self-Register Coach
      'c854870f-3cc3-4780-a96c-cc1fa03c8b3d', // Aephoria Promotions
    ].includes(registerUUID);
    this.setState({ registerUUID, hideCouples: hideCouples, hideCoachBlurb: hideCoachBlurb });
    this.setState({ coachValid: coachValid })
    if (!coachValid)
      return;
    let init;
    try {
      init = await axios.get(`${aserver.getServerRoot()}/pairpay/init/${registerUUID}`);
    } catch (err) {
      this.setState({ coachValid: false })
      return;
    }
    const root = aserver.getServerRoot(true);
    let sroot = root;
    if ((root.includes('3100'))||(root.includes('3000')))
      sroot = init.data.pairpayroot;
    const isFree = !!init.data.isFree;
    let autoPackageFields = {};
    if (hideCouples || isFree) {
      const numAssessments = 2;
      const numReports = 1;
      const totalCost = (numAssessments * init.data.costOfAssessment) + (numReports * init.data.costOfReport);
      autoPackageFields = {
        typeOfPairReport: 'Professional Pairs',
        packageOption: 'option1',
        numAssessments,
        numReports,
        totalCost,
        priceString: this.getPriceString(init.data.currency, totalCost),
        currencyShorthand: "$"
      };
    }
    this.setState({
      return_url: `${root}/coachportal/pairpaymentstatus`,
      cancel_url: `${root}/coachportal/pairpaymentstatus`,
      notify_url: `${sroot}/pairpay/receive_notification/`,
      currency: init.data.currency,
      coachName: init.data.coachName,
      priceString: init.data.priceString,
      costOfAssessment: init.data.costOfAssessment,
      costOfReport: init.data.costOfReport,
      costMap: init.data.costMap,
      isFree: isFree,
      formAction: `https://${init.data.payFastHost}/eng/process`,
      payFastMerchantId: init.data.payFastMerchantId,
      payPalClientId: init.data.payPalClientId,
      payPalEnvironment: init.data.payPalEnvironment,
      ...autoPackageFields
    })
  }

  async initializePostPaymentMode() {
    const checkoutId = localStorage.getItem("checkoutId");
    const registerUUID = localStorage.getItem("registerUUID");
    const packageOption = localStorage.getItem("pairregister_packageOption")
    const typeOfPairReport = localStorage.getItem("pairregister_typeOfPairReport")
    this.setState({
      checkoutId,
      registerUUID,
      packageOption,
      typeOfPairReport
    })
    let previousPaymentState = localStorage.getItem(`paymentTransaction_${checkoutId}`)
    const paymentData = JSON.parse(localStorage.getItem(`paymentData_${checkoutId}`));
    if (previousPaymentState !== "pending") {
      this.setState(paymentData);
    } else {
      this.testPaymentStatus(checkoutId);
    }
  }

  handleMainTypeChange = (partner, e) => {
    const mainType = e.target.value;

    let gutType = '', heartType = '', headType = '';
    if (centers.Gut.includes(Number(mainType))) gutType = mainType;
    if (centers.Heart.includes(Number(mainType))) heartType = mainType;
    if (centers.Head.includes(Number(mainType))) headType = mainType;

    this.setState(
      {
        [`${partner}_enneagram`]: mainType,
        [`${partner}_gutType`]: gutType,
        [`${partner}_heartType`]: heartType,
        [`${partner}_headType`]: headType,
      },
      () => this.updateTrifix(partner)
    );
  };

  handleTriTypeChange = (partner, e) => {
    const { name, value } = e.target;
    this.setState({ [`${partner}_${name}`]: value }, () => this.updateTrifix(partner));
  };

updateTrifix = (partner) => {
  const mainType = this.state[`${partner}_enneagram`];
  const gutType = this.state[`${partner}_gutType`];
  const heartType = this.state[`${partner}_heartType`];
  const headType = this.state[`${partner}_headType`];

  const types = [gutType, heartType, headType];

  const filteredTypes = types.filter(t => t && t !== mainType);

  if (mainType && filteredTypes.length === 2) {
    this.setState({ [`${partner}_trifix`]: `${mainType}${filteredTypes[0]}${filteredTypes[1]}` });
  } else {
    this.setState({ [`${partner}_trifix`]: '' });
  }
};

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    })
  };

  handleDropdownChange = (e) => {
    let { name, value } = e.target;

    if (name==='typeOfPairReport') {
      if ((value==='Professional Pairs')&&(this.state.packageOption !== "option1")) {
        this.setState({[name]: value});
        name = 'packageOption';
        value = 'option1';
      }
    }

    if (name === "packageOption") {
      let numAssessments = 0;
      let numReports = 0;

      if (value === "option1") {
        numAssessments = 2;
        numReports = 1;
      } else if (value === "option2") {
        numAssessments = 0;
        numReports = 1;
      } else if (value === "option3") {
        numAssessments = 1;
        numReports = 1;
      }

    

      const { costOfAssessment, costOfReport, currency } = this.state;
      const totalCost = (numAssessments * costOfAssessment) + (numReports * costOfReport);
      const priceString = this.getPriceString(currency, totalCost);
      const currencyShorthand = currency === "USD" ? "$" : "R";

      this.setState({
        packageOption: value,
        numAssessments,
        numReports,
        totalCost,
        priceString,
        currencyShorthand
      });
      return;
    }

    if (name.includes("_dominantInstinct")) {
      const blindKey = name.replace("_dominantInstinct", "_blindInstinct");

      this.setState((prev) => {
        const newState = { ...prev, [name]: value };
        if (prev[blindKey] === value) {
          newState[blindKey] = "";
        }
        return newState;
      });
      return;
    }

    if (name.includes("_blindInstinct")) {
      const dominantKey = name.replace("_blindInstinct", "_dominantInstinct");

      this.setState((prev) => {
        if (prev[dominantKey] === value) return prev; // cancel
        return { ...prev, [name]: value };
      });
      return;
    }

    this.setState({ [name]: value });
  };

  getPriceString(currency, amount) {
  const symbol = currency === "USD" ? "$" : "R";
  const vatText = currency === "ZAR" ? " including VAT" : "";
  return `${symbol}${amount}${vatText} (${currency})`;
}

  onPayPalFailure = (failureType, message, data) => {
    setCheckoutSpecificField('failureMessage', message);
    this.redirectToPaymentStatus();
  }

  onPayPalSuccess = (checkOutId) => {
    this.redirectToPaymentStatus();
  }

  redirectToPaymentStatus = () => {
    this.setState({
      redirecting: true
    })
    aserver.goto('/coachportal/pairpaymentstatus');      
  }

openInvoiceModal = () => {
  const {
    partnerA_firstName,
    partnerA_lastName,
    partnerA_email,
    partnerB_firstName,
    partnerB_lastName,
    partnerB_email,
    typeOfPairReport,
    packageOption,
    partnerA_enneagram,
    partnerA_trifix,
    partnerA_dominantInstinct,
    partnerA_blindInstinct,
    partnerB_enneagram,
    partnerB_trifix,
    partnerB_dominantInstinct,
    partnerB_blindInstinct
  } = this.state;

  const baseFields = [
    partnerA_firstName,
    partnerA_lastName,
    partnerA_email,
    partnerB_firstName,
    partnerB_lastName,
    partnerB_email,
    typeOfPairReport,
    packageOption
  ];

  if (baseFields.some(f => !f || f.trim() === "")) {
    alert("Please fill in all the base information before continuing.");
    return;
  }

  if (packageOption === "option2") {
    const bothFilled =
      partnerA_enneagram &&
      partnerA_trifix &&
      partnerA_dominantInstinct &&
      partnerA_blindInstinct &&
      partnerB_enneagram &&
      partnerB_trifix &&
      partnerB_dominantInstinct &&
      partnerB_blindInstinct;

    if (!bothFilled) {
      alert("Please complete all conditional fields for both partners before continuing.");
      return;
    }
  } else if (packageOption === "option3") {
    const aFilled =
      partnerA_enneagram &&
      partnerA_trifix &&
      partnerA_dominantInstinct &&
      partnerA_blindInstinct;

    if (!aFilled) {
      alert("Please complete all conditional fields for Partner A before continuing.");
      return;
    }
  }

  this.setState({
    invoiceModal: true
  });
};


  handleProceedClick = () => {
    if (this.state.isFree) {
      this.proceedFreeRegistration();
    } else {
      this.openInvoiceModal();
    }
  };

  proceedFreeRegistration = async () => {
    const {
      partnerA_firstName,
      partnerA_lastName,
      partnerA_email,
      partnerB_firstName,
      partnerB_lastName,
      partnerB_email,
      assessmentType,
      registerUUID,
      partnerA_AssessmentLanguage,
      partnerB_AssessmentLanguage,
      currency,
    } = this.state;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      !partnerA_email || !partnerA_firstName || !partnerA_lastName ||
      !partnerB_email || !partnerB_firstName || !partnerB_lastName ||
      !assessmentType
    ) {
      alert("Please provide all details.");
      return;
    }
    if (!emailRegex.test(partnerA_email) || !emailRegex.test(partnerB_email)) {
      alert("Please provide valid email addresses.");
      return;
    }

    setLocalStorageValue('partnerA_firstName', partnerA_firstName);
    setLocalStorageValue('partnerA_lastName', partnerA_lastName);
    setLocalStorageValue('partnerA_email', partnerA_email);
    setLocalStorageValue('partnerB_firstName', partnerB_firstName);
    setLocalStorageValue('partnerB_lastName', partnerB_lastName);
    setLocalStorageValue('partnerB_email', partnerB_email);

    this.setState({ buttonClicked: true });
    try {
      const checkout = await axios.post(`${aserver.getServerRoot()}/pairpay/checkout`, {
        partnerA_firstName,
        partnerA_lastName,
        partnerA_email,
        partnerB_firstName,
        partnerB_lastName,
        partnerB_email,
        provider: 'Free',
        providerIsPayPal: false,
        amount: 0,
        currency,
        assessmentType,
        registerUUID,
        typeOfPairReport: 'Professional Pairs',
        partnerA_AssessmentLanguage,
        partnerB_AssessmentLanguage,
        packageOption: 'option1'
      });
      await axios.get(`${aserver.getServerRoot()}/pairpay/checkpayment/${checkout.data.checkoutId}`);
      this.setState({ freeRegistrationComplete: true, buttonClicked: false });
    } catch (err) {
      this.setState({
        proceeding: true,
        buttonClicked: false,
        message: err.response?.data?.error?.description || "An error occurred. Please try again.",
      });
    }
  };

  closeModal =()=>{
    this.setState({
      invoiceModal:false
    })
  }

  proceedToPaymentGateway = async () => {
    const {
      partnerA_firstName,
      partnerA_lastName,
      partnerA_email,
      partnerB_firstName,
      partnerB_lastName,
      partnerB_email,
      assessmentType,
      registerUUID,
      partnerA_AssessmentLanguage,
      partnerB_AssessmentLanguage,
      currency,
      totalCost,
      priceString,
      typeOfPairReport,
      packageOption,
      partnerA_enneagram,
      partnerA_trifix,
      partnerA_dominantInstinct,
      partnerA_blindInstinct,
      partnerB_enneagram,
      partnerB_trifix,
      partnerB_dominantInstinct,
      partnerB_blindInstinct,
    } = this.state;

    const provider = (currency === 'ZAR' ? providerPayFast : providerPayPal);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      !partnerA_email ||
      !partnerA_firstName ||
      !partnerA_lastName ||
      !partnerB_email ||
      !partnerB_firstName ||
      !partnerB_lastName ||
      !assessmentType
    ) {
      alert("Please provide all details.");
      return;
    }

    if (!emailRegex.test(partnerA_email) || !emailRegex.test(partnerB_email)) {
      alert("Please provide valid email addresses.");
      return;
    }

    // Save to local storage
    setLocalStorageValue('partnerA_firstName', partnerA_firstName);
    setLocalStorageValue('partnerA_lastName', partnerA_lastName);
    setLocalStorageValue('partnerA_email', partnerA_email);
    setLocalStorageValue('partnerB_firstName', partnerB_firstName);
    setLocalStorageValue('partnerB_lastName', partnerB_lastName);
    setLocalStorageValue('partnerB_email', partnerB_email);
    setLocalStorageValue('partnerA_AssessmentLanguage', partnerA_AssessmentLanguage);
    setLocalStorageValue('partnerB_AssessmentLanguage', partnerB_AssessmentLanguage);
    setLocalStorageValue('typeOfPairReport', typeOfPairReport);
    setLocalStorageValue('packageOption', packageOption);
    const pfItemNameMap = {
      option1: `Aephoria ${typeOfPairReport} Report + 2 Assessments`,
      option2: `Aephoria ${typeOfPairReport} Report `,
      option3: `Aephoria ${typeOfPairReport} Report + 1 Assessment`
    }
    try {
      this.setState({
        buttonClicked: true,
        proceeding: provider === providerPayFast,
        pfItemName: pfItemNameMap[packageOption]
      });

      // Base payload
      let payload = {
        partnerA_firstName,
        partnerA_lastName,
        partnerA_email,
        partnerB_firstName,
        partnerB_lastName,
        partnerB_email,
        provider,
        providerIsPayPal: provider === providerPayPal,
        amount: totalCost,
        currency,
        assessmentType,
        registerUUID,
        typeOfPairReport,
        partnerA_AssessmentLanguage,
        partnerB_AssessmentLanguage,
        packageOption
      };

      // Add data conditionally based on option selected
      if (packageOption === "option2") {
        payload = {
          ...payload,
          partnerA_enneagram,
          partnerA_trifix,
          partnerA_dominantInstinct,
          partnerA_blindInstinct,
          partnerB_enneagram,
          partnerB_trifix,
          partnerB_dominantInstinct,
          partnerB_blindInstinct,
        };
      } else if (packageOption === "option3") {
        payload = {
          ...payload,
          partnerA_trifix,
          partnerA_dominantInstinct,
          partnerA_blindInstinct,
          partnerA_AssessmentLanguage
        };
      }

      // Send checkout request
      const checkout = await axios.post(`${aserver.getServerRoot()}/pairpay/checkout`, payload);

      if (checkout.status === 200) {
        this.setState({
          checkoutId: checkout.data.checkoutId,
          provider,
          proceeding: true,
          showPayPalButtons: provider === providerPayPal,
          message: (
            <>
              {provider === providerPayFast && <p>Please wait, redirecting to PayFast.</p>}
              <p>
                You will be paying for your pairs report package a total of {priceString}.
              </p>
              {provider === providerPayPal && (
                <p>Please click on the PayPal button to start the payment process.</p>
              )}
            </>
          ),
        });

        localStorage.setItem("checkoutId", checkout.data.checkoutId);
        localStorage.setItem("registerUUID", registerUUID);
        localStorage.setItem(`paymentTransaction_${checkout.data.checkoutId}`, "pending");
      } else {
        this.setState({ message: checkout.data.error, proceeding: true });
      }
    } catch (err) {
      this.setState({
        message: err.response?.data?.error?.description || "An error occurred. Please try again.",
        proceeding: true,
      });
    }
  };


  componentDidUpdate(prevProps, prevState) {
    if (this.state.mode === modeRegister) {
      if (this.state.checkoutId && prevState.checkoutId !== this.state.checkoutId) {
        if (this.state.provider === providerPayFast) {
          document.PayFastPayNowForm.submit();
        }
      }
    }
  }

  testPaymentStatus = async (checkoutId) => {
    if (!checkoutId)
      checkoutId = this.state.checkoutId;
    try {
      let response = await axios.get(`${aserver.getServerRoot()}/pairpay/checkpayment/${checkoutId}`);
      let checkStatus = response.data;
      let status = '';
      let paymentData = {};
      if (checkStatus.success) {
        paymentData = {
          isPaymentComplete: checkStatus.success,
          name: checkStatus.name,
          surname: checkStatus.surname,
          email: checkStatus.email,
          priceString: checkStatus.priceString,
          assessmentType: checkStatus.assessmentType,
          assessmentLanguage: checkStatus.assessmentLanguage,
        };
        status = 'success';
      } else if (checkStatus.pending) {
        paymentData = {
          bodyText: "Please wait, still checking.",
        };
        status = 'pending';
        setTimeout(this.testPaymentStatus, 30000);
      } else {
        paymentData = {
          bodyText: checkStatus.paymentNotes,
          failureMessage: getCheckoutSpecificField('failureMessage')
        };
        status = 'fail';
      }
      paymentData.referenceNumber = checkStatus.referenceNumber;
      paymentData.registerUUID = this.state.registerUUID;
      this.setState(paymentData);
      localStorage.setItem(`paymentData_${checkoutId}`, JSON.stringify(paymentData));
      localStorage.setItem(`paymentTransaction_${checkoutId}`, status)
    } catch (err) {
      this.setState({ 
        bodyText: err.toString(),
        registerUUID: this.state.registerUUID
      });
    }
  };

  render() {
    let showBody = <></>

    if (this.state.mode === modePostPayment) {
      const { 
        partnerA_firstName, partnerA_lastName, partnerB_firstName, partnerB_lastName, 
        priceString, partnerA_email, partnerB_email, typeOfPairReport, 
        bodyText, referenceNumber, failureMessage, packageOption 
      } = this.state;

      showBody = (
        <div>
          <p>
            {!this.state.isPaymentComplete && <>
              {failureMessage && <p>{failureMessage}</p>}
              {bodyText}
              {referenceNumber && <p>Your reference number is {referenceNumber}.</p>}
              <p>
                If you want to start the registration process again, please click <a href={`/coachportal/register/${this.state.registerUUID}`}>here</a>.
              </p>
            </>}
            
            {this.state.isPaymentComplete && <>
              Dear {partnerA_firstName} {partnerA_lastName} and {partnerB_firstName} {partnerB_lastName},<br /><br />
              We are delighted to inform you that your purchase of your Aephoria Pairs Self-Register package has been successfully processed. The total amount paid is {priceString}.<br /><br />

              {packageOption === "option1" && <>
                Both you and {partnerB_firstName} {partnerB_lastName} will need to complete your assessments. 
                Your {typeOfPairReport} report will be available within two working days after both your assessments are completed.<br /><br />
                Invitations to complete your assessments have been emailed to you at {partnerA_email} and {partnerB_email}.
              </>}

              {packageOption === "option2" && <>
                No assessments are required. Your {typeOfPairReport} report will be available within two working days.
              </>}

              {packageOption === "option3" && <>
                Only {partnerB_firstName} {partnerB_lastName} needs to complete their assessment. 
                Your {typeOfPairReport} report will be available within two working days after {partnerB_firstName} {partnerB_lastName} has completed their assessment.<br /><br />
                An invitation to complete the assessment have been emailed to {partnerB_firstName} {partnerB_lastName} at {partnerB_email}.
              </>}

              {referenceNumber && <><br /><br />Your reference number is {referenceNumber}.</>}<br/><br/>
              If you have any questions or need assistance, please contact us at hello@aephoriagroup.com.<br /><br />
              Best regards,<br />
              Aephoria

            </>}
          </p>
        </div>
      );
    }

    if (this.state.mode === modeRegister) {
      const { isFree } = this.state;
      if (!this.state.coachValid) {
        showBody = <>
            Invalid link. Please use the link exactly as provided to you by your coach, and contact your coach for a new link if it still doesn't work.
        </>
      } else if (this.state.freeRegistrationComplete) {
        showBody = <p>
          Dear {this.state.partnerA_firstName} {this.state.partnerA_lastName} and {this.state.partnerB_firstName} {this.state.partnerB_lastName},<br/><br/>
          Your registration is complete. Invitations to complete your assessments have been emailed to you at {this.state.partnerA_email} and {this.state.partnerB_email}.<br/><br/>
          The results of your assessment(s) will be emailed to you on completion.<br/><br/>
          If you have any questions or need assistance, please contact us at hello@aephoriagroup.com.<br/><br/>
          Best regards,<br/>
          Aephoria
        </p>
      } else {
        showBody = <>
          {this.state.redirecting?<div>Please wait...</div>:
          <div style={{ display: this.state.proceeding ? "block" : "none" }}>
            <p>{this.state.message}</p>
            {/*//is this message still needed?
            <p style={{ margin: "0", display: this.state.message && this.state.currency === "USD" ? "block" : "none" }}>We are unable to process payments with Amex in USD.</p>
            */}
            <p>
            {this.state.showPayPalButtons&&<PayPal
              paypalCaptureUrl ={this.state.paypalCaptureUrl}
              payPalClientId={this.state.payPalClientId}
              payPalEnvironment={this.state.payPalEnvironment}
              onFailure={this.onPayPalFailure}
              onSuccess={this.onPayPalSuccess}
            />}
            </p>
          </div>}
          <div style={{ display: !this.state.proceeding ? "block" : "none" }}>
            <form name="PayFastPayNowForm" action={this.state.formAction} method="post">
              <input required type="hidden" name="cmd" value="_paynow" />
              <input required type="hidden" name="receiver" pattern="[0-9]" value={this.state.payFastMerchantId} />
              <input required type="hidden" name="payment_method" value="cc" />
              <input type="hidden" name="name_first" value={this.state.partnerA_firstName} />
              <input type="hidden" name="name_last" value={this.state.partnerA_lastName} />
              <input type="hidden" name="return_url" value={this.state.return_url} />
              <input type="hidden" name="cancel_url" value={this.state.cancel_url} />
              <input type="hidden" name="notify_url" value={this.state.notify_url} />
              <input type="hidden" name="custom_str1" value={this.state.checkoutId} />
              <input type="hidden" name="email_address" value={this.state.partnerA_email} />
              <input required type="hidden" name="amount" value={this.state.totalCost} />
              <input required type="hidden" name="item_name" maxLength="255" value={this.state.pfItemName} />
              <input type="hidden" name="item_description" maxLength="255" value={pfItemDescription} />
            </form>

            {!isFree && <>
            <div className={`styled-select-pair input-wrapper-1${this.state.hideCouples ? " is-disabled" : ""}`}>
              <select id="dropdown" name="typeOfPairReport" disabled={this.state.hideCouples} onChange={this.handleDropdownChange} value={this.state.typeOfPairReport} required>
                <option hidden>Type of Report</option>
                <option value="Professional Pairs">Professional Pairs</option>
                {!this.state.hideCouples && (
                  <option value="Couples">Couples</option>
                )}
              </select>
            </div>
            <div className={`styled-select-pair input-wrapper-1${this.state.hideCouples ? " is-disabled" : ""}`}>
              <select id="dropdown" name="packageOption" disabled={this.state.hideCouples} onChange={this.handleDropdownChange} value={this.state.packageOption} required>
                <option hidden>Your Package</option>
                <option value="option1">We both want an individual Aephoria Enneagram assessment + Pairs Report</option>
                {this.state.typeOfPairReport !== "Professional Pairs" && (
                      <>
                        <option value="option2">We both have existing Enneagram data and just want a Pairs Report</option>
                        <option value="option3">One of us has Enneagram data, and one of us needs an individual Aephoria Enneagram assessment</option>
                      </>
                    )}
              </select>
            </div>
            </>}
            <div className="splitForm">
              {/*================================= Partner A Section ================================*/}
              <div className="partnerSection">
                <h5 className="selfRegisterHeading">Partner A</h5>
                <div className="input-wrapper-1 addClientDiv">
                  <input type="text" name="partnerA_firstName" id="partnerA_firstName" onChange={this.handleChange} value={this.state.partnerA_firstName} autoFocus />
                  <label className="edit">Name</label>
                </div>
                <div className="input-wrapper-1 addClientDiv">
                  <input type="text" name="partnerA_lastName" id="partnerA_lastName" onChange={this.handleChange} value={this.state.partnerA_lastName} />
                  <label className="edit">Surname</label>
                </div>
                <div className="input-wrapper-1 addClientDiv">
                  <input type="text" name="partnerA_email" id="partnerA_email" onChange={this.handleChange} value={this.state.partnerA_email} />
                  <label className="edit">Email</label>
                </div>
                {/*=============================================== Partner A Assessment details================================== */}
                {this.state.packageOption &&
                <div style={{ display: this.state.packageOption==="option2"||this.state.packageOption==="option3"?"none":"block"}}>
                  <h5 className="selfRegisterHeading">Assessment Details</h5>
                  <div className="styled-select-pair input-wrapper-1">
                    <select id="dropdown" onChange={this.handleChange} style={{ textTransform: "capitalize" }} name="partnerA_AssessmentLanguage" value={this.state.partnerA_AssessmentLanguage} required>
                      {aserver.Languages.sort().map((info, i) => {
                        return (
                          <option key={i} value={info}>{info.charAt(0).toUpperCase() + info.slice(1)}</option>
                        )
                      })}
                    </select>
                    <label>Language</label>
                  </div>
                </div>
                }
                {/* Partner A Enneagram Section */}
                {(this.state.packageOption === "option2" || this.state.packageOption === "option3") && (
                  <>
                    <div className="styled-select-pair input-wrapper-1">
                      <select
                        name="partnerA"
                        onChange={(e) => this.handleMainTypeChange('partnerA', e)}
                        value={this.state.partnerA_enneagram}
                      >
                        <option hidden>Select Enneagram Type (1-9)</option>
                        {[...Array(9)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>{i + 1}</option>
                        ))}
                      </select>
                      <label>Enneagram Type</label>
                    </div>
                    {this.state.partnerA_enneagram && (
                      <>
                      <div className="centersDiv">
                        {Object.entries(centers).map(([center, values]) => (<>
                        <div className="styled-select-pair-centers" style={{ borderColor: values.includes(Number(this.state.partnerA_enneagram))?"grey":"#00447d"}}>
                          <select
                            key={center}
                            name={`${center.toLowerCase()}Type`}
                            onChange={(e) => this.handleTriTypeChange('partnerA', e)}
                            value={this.state[`partnerA_${center.toLowerCase()}Type`]}
                            disabled={values.includes(Number(this.state.partnerA_enneagram))}
                            style={{ color: values.includes(Number(this.state.partnerA_enneagram))?"grey":"#00447d"}}
                          >
                            <option hidden>select</option>
                            {values.map(v => <option key={v} value={v}>{v}</option>)}
                          </select>
                          <label>{center}</label>
                        </div>
                          </>
                        ))}
                      </div>
                      <div className="input-wrapper-1 addClientDiv">
                        <input type="text" value={this.state.partnerA_trifix} readOnly disabled/>
                        <label className="edit">TriType</label>
                      </div>
                      </>
                    )}
                    <div className="styled-select-pair input-wrapper-1">
                      <select
                        id="dominantInstinct"
                        name="partnerA_dominantInstinct"
                        onChange={this.handleDropdownChange}
                        value={this.state.partnerA_dominantInstinct}
                        required
                      >
                        <option hidden>Select Dominant Instinct</option>
                        <option value="SP">Self-Preservation</option>
                        <option value="SO">Social</option>
                        <option value="SX">Sexual</option>
                      </select>
                      <label>Dominant Instinct</label>
                    </div>
                    <div className="styled-select-pair input-wrapper-1">
                      <select
                        id="blindInstinct"
                        name="partnerA_blindInstinct"
                        onChange={this.handleDropdownChange}
                        value={this.state.partnerA_blindInstinct}
                        required
                      >
                        <option hidden>Select Blind Instinct</option>
                        <option value="SP" disabled={this.state.partnerA_dominantInstinct === "SP"}>Self-Preservation</option>
                        <option value="SO" disabled={this.state.partnerA_dominantInstinct === "SO"}>Social</option>
                        <option value="SX" disabled={this.state.partnerA_dominantInstinct === "SX"}>Sexual</option>
                      </select>
                      <label>Blind Instinct</label>
                    </div>
                  </>
                )}
              </div>

              {/*============================================ Partner B Section ======================================*/}
              <div className="partnerSection">
                <h5 className="selfRegisterHeading">Partner B</h5>
                <div className="input-wrapper-1 addClientDiv">
                  <input type="text" name="partnerB_firstName" id="partnerB_firstName" onChange={this.handleChange} value={this.state.partnerB_firstName} />
                  <label className="edit">Name</label>
                </div>
                <div className="input-wrapper-1 addClientDiv">
                  <input type="text" name="partnerB_lastName" id="partnerB_lastName" onChange={this.handleChange} value={this.state.partnerB_lastName} />
                  <label className="edit">Surname</label>
                </div>
                <div className="input-wrapper-1 addClientDiv">
                  <input type="text" name="partnerB_email" id="partnerB_email" onChange={this.handleChange} value={this.state.partnerB_email} />
                  <label className="edit">Email</label>
                </div>
                {/*=============================================== Partner B Assessment details================================== */}
                {this.state.packageOption &&
                <div style={{ display: this.state.packageOption==="option2"?"none":"block"}}>
                  <h5 className="selfRegisterHeading">Assessment Details</h5>
                  <div className="styled-select-pair input-wrapper-1">
                    <select id="dropdown" onChange={this.handleChange} style={{ textTransform: "capitalize" }} name="partnerB_AssessmentLanguage" value={this.state.partnerB_AssessmentLanguage} required>
                      {aserver.Languages.sort().map((info, i) => {
                        return (
                          <option key={i} value={info}>{info.charAt(0).toUpperCase() + info.slice(1)}</option>
                        )
                      })}
                    </select>
                    <label>Language</label>
                  </div>
                </div>
                }
                {/* Partner B Enneagram Section */}
                {(this.state.packageOption === "option2" || this.state.packageOption === "option3") && this.state.packageOption !== "option3" && (
                  <>
                    <div className="styled-select-pair input-wrapper-1">
                      <select
                        name="partnerB"
                        onChange={(e) => this.handleMainTypeChange('partnerB', e)}
                        value={this.state.partnerB_enneagram}
                      >
                        <option hidden>Select Enneagram Type (1-9)</option>
                        {[...Array(9)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>{i + 1}</option>
                        ))}
                      </select>
                      <label>Enneagram Type</label>
                    </div>
                    {this.state.partnerB_enneagram && (
                      <>
                      <div className="centersDiv">
                        {Object.entries(centers).map(([center, values]) => (<>
                        <div className="styled-select-pair-centers" style={{ borderColor: values.includes(Number(this.state.partnerB_enneagram))?"grey":"#00447d"}}>
                          <select
                            key={center}
                            name={`${center.toLowerCase()}Type`}
                            onChange={(e) => this.handleTriTypeChange('partnerB', e)}
                            value={this.state[`partnerB_${center.toLowerCase()}Type`]}
                            disabled={values.includes(Number(this.state.partnerB_enneagram))}
                            style={{ color: values.includes(Number(this.state.partnerB_enneagram))?"grey":"#00447d"}}
                          >
                            <option hidden>select</option>
                            {values.map(v => <option key={v} value={v}>{v}</option>)}
                          </select>
                          <label>{center}</label>
                        </div>
                        </>
                        ))}
                      </div>
                      <div className="input-wrapper-1 addClientDiv">
                        <input type="text" value={this.state.partnerB_trifix} readOnly disabled/>
                        <label className="edit">TriType</label>
                      </div>
                      </>
                    )}
                    <div className="styled-select-pair input-wrapper-1">
                      <select
                        id="dominantInstinct"
                        name="partnerB_dominantInstinct"
                        onChange={this.handleDropdownChange}
                        value={this.state.partnerB_dominantInstinct}
                        required
                      >
                        <option hidden>Select Dominant Instinct</option>
                        <option value="SP">Self-Preservation</option>
                        <option value="SO">Social</option>
                        <option value="SX">Sexual</option>
                      </select>
                      <label>Dominant Instinct</label>
                    </div>
                    <div className="styled-select-pair input-wrapper-1">
                      <select
                        id="blindInstinct"
                        name="partnerB_blindInstinct"
                        onChange={this.handleDropdownChange}
                        value={this.state.partnerB_blindInstinct}
                        required
                      >
                        <option hidden>Select Blind Instinct</option>
                        <option value="SP" disabled={this.state.partnerB_dominantInstinct === "SP"}>Self-Preservation</option>
                        <option value="SO" disabled={this.state.partnerB_dominantInstinct === "SO"}>Social</option>
                        <option value="SX" disabled={this.state.partnerB_dominantInstinct === "SX"}>Sexual</option>
                      </select>
                      <label>Blind Instinct</label>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div>
              {isFree||(this.state.hideCoachBlurb) ? (
                <p>
                  The results of your assessments will be emailed to you on completion.
                </p>
              ) : (
                !this.state.hideCoachBlurb && (
                  <p>
                    The results of your assessment and associated reports will be made available to {this.state.coachName}.
                  </p>
                )
              )}
              <p>
                By clicking on "Proceed", you agree to <a href="https://aephoriagroup.com/general-terms/" target="_blank">our general terms.</a>
              </p>
            </div>
            <div className="registrationButton">
              <Button variant="contained" color="primary" type="submit" disabled={this.state.buttonClicked} onClick={() => this.handleProceedClick()}>{this.state.buttonClicked?'Please wait...':'Proceed'}</Button>
            </div>
            <Modal isOpen={this.state.invoiceModal} onClose={() => this.closeModal()}>
              <h3>Invoice Breakdown</h3>
              <p style={{display:this.state.numAssessments===0?"none":"block"}}>{this.state.numAssessments} x assessments at {this.state.currencyShorthand}{this.state.costOfAssessment} = {this.state.currencyShorthand}{(this.state.numAssessments * this.state.costOfAssessment)}</p>
              <p>1 x Pair Report = {this.state.currencyShorthand}{this.state.costOfReport}</p>
              <p>Your total: {this.state.priceString}</p>
              <Button variant="contained" color="primary" type="submit" onClick={() => this.proceedToPaymentGateway()}>Ok</Button>
              <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
            </Modal>
          </div>
        </>
      }
    }

    return (
      <main className="pairRegister" >
        {/* <img className="registerFormLogo top-div" src={AephoriaLogo} alt="Aephoria Lab Logo" /> */}
        <div className="pairSelfregisterForm middle-div">
          <div className="selfRegisterFormContent">
            <h1 style={{ "textAlign": "center", "margin": "1vh" }}>{this.state.isFree ? 'Free Professional Pairs Enneagram Assessment Registration' : (this.state.hideCouples?'Professional Pairs Enneagram Assessment Registration':'Enneagram Pairs Report')}</h1>
            {showBody}
          </div>
        </div>
      </main>
    );
  }
}

export default PairRegister
